// ADR-0010 Fatia 1 — backfill do keypair do membro no login (auto-cura, NÃO-FATAL).
//
// Chamado no LoginPage logo após storeKekMembro, com a KEK_membro raw disponível.
// Se o membro ainda não tem keypair, gera o par RSA-OAEP-2048 NO BROWSER, embrulha
// a privada sob a KEK e POSTa pro servidor (que SÓ persiste — nunca vê a privada em
// claro). NUNCA lança: qualquer falha (keygen, rede, flag OFF, já-enrolado) vira um
// resultado e o login segue normal. O próximo login re-tenta (idempotente; o
// servidor first-writer-wins é o guard real).

import { generateAndWrapMemberKeypair } from '@aions/crypto';
import { apiFetch } from './auth-client';

export type BackfillResult =
  | { ok: true }
  | { ok: false; skipped: 'disabled' | 'already_enrolled' | 'error'; status?: number };

/**
 * Gera+embrulha+sobe o keypair do membro. NÃO-FATAL por contrato: retorna sempre,
 * nunca lança. `kekRaw` é a KEK_membro de 32 bytes (a mesma do storeKekMembro);
 * o caller a zera depois (kekRaw.fill(0)) — por isso aguardamos o POST antes.
 */
export async function backfillMemberKeypair(kekRaw: Uint8Array): Promise<BackfillResult> {
  try {
    const wrapped = await generateAndWrapMemberKeypair(kekRaw);
    const resp = await apiFetch('/api/comite/enroll-keypair', {
      method: 'POST',
      body: JSON.stringify(wrapped),
    });
    if (resp.ok) return { ok: true };
    // 404 = flag COMITE_READ_ENABLED OFF naquele env. 409 = já enrolado (other device/retry).
    if (resp.status === 404) return { ok: false, skipped: 'disabled', status: 404 };
    if (resp.status === 409) return { ok: false, skipped: 'already_enrolled', status: 409 };
    return { ok: false, skipped: 'error', status: resp.status };
  } catch {
    // NUNCA propaga — o login do membro não pode quebrar por causa do keypair.
    return { ok: false, skipped: 'error' };
  }
}
